import React from "react";
import { PremiumTrialExpirationTemplate } from "themes/application/payment/components";

function PremiumTrialExpiration(props) {
    return <PremiumTrialExpirationTemplate {...props} />;
}

export default PremiumTrialExpiration;
